import { getList as _getList, getOneById as _getOneById } from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/general/cp-payments";

const DEFAULT_LIST_DATA = {
    status: "SUCCEEDED",
    page: 0,
    size: 15,
    sort: "payment_creation_datetime,desc",
};

function normalizePaymentData(data) {
    const { paymentCreationDatetime, statusConfirmationDatetime } = data;

    return {
        ...data,
        paymentCreationDatetimeString: dateToString(paymentCreationDatetime),
        statusConfirmationDatetimeString: dateToString(statusConfirmationDatetime),
    };
}

function normalizeData(data) {
    return data.map(normalizePaymentData);
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({
        url: `${BASE_URL}/${id}`,
        onSuccess,
        onError,
        normalizer: normalizePaymentData,
    });
}
